export default __webpack_public_path__ + "static/media/Dry_Acid.0a004671.webp";